module.exports = __webpack_public_path__ + "img/stop01.bec3ef77.png";